import { CartItems, VoucherApplicableTickets } from 'types/CartItem';
import {
  isTicket,
  SelectedBundle,
  SelectedSeat,
  SelectedTicket,
} from 'types/SelectedItem';
import { Ticket } from 'types/TicketsState';
import { getTaxPrice, roundUpDecimals } from './tickets';

// items: [
//   {
//     price: "100.00",
//     currency: "RON",
//     item_name: "VIP",
//     item_brand: "Oveit",
//     index: 0
//   }
// ]

interface GtmCartItem {
  price: number;
  currency: string;
  quantity: number;
  item_name: string;
  item_brand: string;
  item_category: string;
  index: number;
  coupon?: string;
}

export const parseEventTicketsForGTM = (items: Ticket[], taxRate: number) =>
  items.map(({ ticketprice, name }, index) => ({
    price: roundUpDecimals(
      ticketprice[0].price + getTaxPrice(ticketprice[0].price, taxRate),
    ),
    currency: ticketprice[0].currency,
    item_name: name,
    item_brand: 'Oveit',
    item_category: 'Event Tickets',
    index,
  }));

export const parseCartItemsForGTM = (
  items: CartItems | (SelectedTicket | SelectedSeat | SelectedBundle)[],
  currency: string,
  voucherName: string,
  voucherApplicableTickets: VoucherApplicableTickets,
) =>
  items.map((item, index) => {
    const { price, tax, name, quantity } = item;
    const result: GtmCartItem = {
      price: roundUpDecimals(price + tax),
      currency,
      quantity,
      item_name: name,
      item_category: 'Event Tickets',
      item_brand: 'Oveit',
      index,
    };

    if (
      isTicket(item) &&
      voucherApplicableTickets.findIndex(
        elementId => elementId === item.ticketId,
      ) >= 0
    ) {
      result.coupon = voucherName;
    }

    return result;
  });

export const parseOrderItemsForGTM = items =>
  items.map(
    (
      {
        details: {
          price,
          currency,
          tax,
          name,
          full_name,
          quantity,
          type,
          voucherCode,
        },
      },
      index,
    ) => {
      const result: GtmCartItem = {
        price: price + tax,
        currency,
        quantity,
        item_name: type === 'ticket' ? name : full_name,
        item_category: 'Event Tickets',
        item_brand: 'Oveit',
        index,
      };

      if (voucherCode) {
        result.coupon = voucherCode;
      }

      return result;
    },
  );
